import { Footer } from './components/Footer'
import { BarcodeAttachment } from './fields/BarcodeAttachment/BarcodeAttachment'
import { MobileFutureDaysVisibility } from './fields/MobileFutureDaysVisibility/MobileFutureDaysVisibility'
import { SummarizeFutureMobileRoute } from './fields/SummarizeFutureMobileRoute/SummarizeFutureMobileRoute'
import { form } from './formState'
import { useFormConfig } from './hooks/useFormConfig'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'

type BulkDriverFormProps = {
  drivers: uui.domain.client.rm.ExtendedDriver[]
}

export function BulkDriverForm(props: BulkDriverFormProps) {
  const { drivers } = props
  const { header, driverAppTitle } = useTexts()

  const config = useFormConfig(drivers)
  const onSubmit = useOnSubmit(drivers)

  return (
    <form.Form
      title={header.title(drivers.length)}
      testId="bulk-driver-form"
      config={config}
      onSubmit={onSubmit}
      requireTransaction
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
      rightBorder
      footer={<Footer />}
    >
      <form.SectionTitle>{driverAppTitle}</form.SectionTitle>
      <BarcodeAttachment />
      <MobileFutureDaysVisibility />
      <SummarizeFutureMobileRoute />
    </form.Form>
  )
}
